<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="page1"></a>
<p class="part-number"><a href="#/Text/part0004#part-1">SECTION ONE</a></p>
<p class="part-title"><a href="#/Text/part0004#part-1">TRUCKBOX AL’S<br/>BIG BREAK</a></p>
<a id="page2"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0005.vue?24fb3076